module.exports = __webpack_public_path__ + "img/photo_archive_1.93b5a1eb.jpg";